module.exports = __webpack_public_path__ + "static/img/buy.5eaa988f.png";